import { Container, Row } from 'react-bootstrap';
import BarChart from './BarChart';

const BarChartDemo = () => {
  let data = [
    {
      color: '#2268E2',
      value: 30,
      name: 'finalPrice',
      label: 'Final Average Pay Plan',
    },
    {
      color: '#F93B1D',
      value: 15,
      name: 'balance',
      label: 'Cash balance plan',
    },
    { color: '#10A84A', value: 50, name: 'frozenPlan', label: 'Frozen Plan' },
  ];

  let data2: any[] = [
    {
      color: '#2268E2',
      value: 0,
      name: 'finalPrice',
      label: 'Final Average Pay Plan',
    },
    {
      color: '#F93B1D',
      value: 0,
      name: 'balance',
      label: 'Cash balance plan',
    },
    { color: '#10A84A', value: 0, name: 'frozenPlan', label: 'Frozen Plan' },
  ];

  let terminationPrice = 3583;
  let beneficiaryPrice = 0;

  let ageOfPension = 65;

  return (
    <Container>
      <Container className="mt-10">
        <h4>BarChart Demo</h4>
        <Container className="d-flex flex-column">
          <Row className="m-0">
            <BarChart
              data={data}
              total={terminationPrice}
              showLegend={false}
              label={
                'Termination at age ' +
                ageOfPension +
                ' and Payments begin at age ' +
                ageOfPension
              }
            />
          </Row>
          <Row className="m-0 mt-10">
            <BarChart
              data={data2}
              total={beneficiaryPrice}
              showLegend={true}
              label={'Beneficiary payments upon your death'}
            />
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

export default BarChartDemo;
